// extracted by mini-css-extract-plugin
module.exports = {"note":"style-module_note__1JwNDjZAJj787d2ULT9Y7t"};